module.exports = __webpack_public_path__ + "static/media/fondo_conjunto.69984f10.jpg";